<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="标题设置:" prop="titleSet">
                                <el-checkbox v-model="value.titleSet">商品标题超过平台限制自动截断（最多60个字符）</el-checkbox>
                            </el-form-item>
                            <el-form-item label="物流配置（所在地）:" prop="logisticsSet">
                                <el-select-address v-model="value.address" :widths="['150px', '150px', -1, -1]" />
                            </el-form-item>
                            <el-form-item label="天猫外部商家编码设置:" prop="isAutoFillOuterId">
                                <el-checkbox v-model="value.isAutoFillOuterId" :true-label="1" :false-label="0">基础资料款式编码自动填充天猫外部商家编码</el-checkbox>
                                <span style="color: red; font-size: 12px">&nbsp;（注意：开启配置，新增天猫资料时，基础资料款式编码自动填充天猫外部商家编码，若天猫资料已完善，则不会自动填充。）</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>

                        <div class="conf" style="padding-left:15%;">
                            <el-table :data="imageMappingTableData" border style="width: 900px;">
                                <el-table-column prop="name" label="图片项" width="200">
                                    <template slot-scope="{ row }">
                                        <span v-if="row.type === 'vertical'">商品竖图</span>
                                        <span v-else-if="row.type === 'transparent'">透明素材图</span>
                                        <span v-else-if="row.type === 'param'">产品参数图片</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="映射规则" min-width="700">
                                    <template slot-scope="{ row }">
                                        <!-- 商品竖图 -->
                                        <div v-if="row.type === 'vertical'" class="mapping-rule">
                                            <ImageMappingConfig
                                                v-model="value.verticalImageConfigVO"
                                                base-label="基础资料商品长图"
                                            />
                                        </div>
                                        <!-- 透明素材图 -->
                                        <div v-else-if="row.type === 'transparent'" class="mapping-rule">
                                            <ImageMappingConfig
                                                v-model="value.transparentImageConfigVO"
                                                base-label="基础资料白底图"
                                            />
                                        </div>
                                        <!-- 产品参数图片 -->
                                        <div v-else-if="row.type === 'param'" class="mapping-rule">
                                            <div class="rule-line">
                                                <el-checkbox
                                                    v-model="value.productParamImageConfigVO.useCommonConfig"
                                                    @change="handleProductParamImageChange"
                                                >
                                                    通用配置
                                                </el-checkbox>
                                                <ImgUpload
                                                    :key="value.productParamImageConfigVO.commonImageUrl"
                                                    :file="value.productParamImageConfigVO.commonImageUrl"
                                                    :is-single="true"
                                                    :width="80"
                                                    :height="80"
                                                    @upload-success="(url) => value.productParamImageConfigVO.commonImageUrl = url"
                                                    @del="value.productParamImageConfigVO.commonImageUrl = ''"
                                                />
                                                <el-checkbox
                                                    v-model="value.productParamImageConfigVO.useCategoryConfig"
                                                    @change="handleProductParamImageChange"
                                                >
                                                    按类目配置 (已配置：<span style="color: red;">{{ categoryConfigCount || 0 }}</span>)
                                                </el-checkbox>
                                                <el-link
                                                    type="primary"
                                                    style="margin-left: 8px;"
                                                    @click="openCategoryConfigDialog"
                                                >
                                                    查看详情
                                                </el-link>
                                            </div>
                                            <div class="rule-tip">优先按照类目配置取值，若无类目取值，则按照通用配置映射产品参数图片</div>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        
                        <div class="conf">
                            <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，需调整后重新上传。</div>
                            <el-form-item prop="autoCropImageConfigList">
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="itemImages">商品图片</el-checkbox>
                                    <el-checkbox label="mainImg34">3:4商品图片</el-checkbox>
                                    <el-checkbox label="verticalImage">商品竖图</el-checkbox>
                                    <el-checkbox label="whiteBgImage">透明素材图</el-checkbox>
                                    <el-checkbox label="wirelessDesc">手机端详情描述</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section>
                    
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到天猫到SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{ item.shortTitle || item.title }}</span>
                                        </div>
                                        <el-select 
                                            :loading="selectLoading" 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            @visible-change="changeSelect(item.id, item.userId)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <!-- <el-radio :label="3">定时上架</el-radio> -->
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>售后配置</span>
                        </div>
                        <div class="conf">
                            <div><el-button @click="handleAdd">新增配置</el-button><el-button @click="handleBatchDelete">批量删除</el-button></div>
                            <el-table :data="tableData" :highlight-current-row="true"
                                @selection-change="handleSelectionChange" mouse-select-range style="width: 100%">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="configDetail" label="配置详情" width="500"></el-table-column>
                                <el-table-column prop="shops" label="适配店铺" width="180">
                                    <template slot-scope="scope">
                                        <span v-for="(shop, index) in scope.row.shops" :key="index">
                                            <el-image :src="shop.icon" style="width: 12px;" />
                                            {{ shop.title }}<span v-if="index < scope.row.shops.length - 1">, </span>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="options" label="操作">
                                    <template slot-scope="scope">
                                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                        <el-button size="mini" type="text" @click="showShopSelect(scope.$index, scope.row)">关联店铺</el-button>
                                        <el-button size="mini" type="text" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <div style="color:red">
                            <div>注意：</div>
                            <div>1、售后配置仅对未完善的天猫资料生效，铺货以保存的天猫资料为准；</div>
                            <div>2、若默认配置项与平台返回的配置项冲突，以平台返回的配置项为准，例：默认配置发票为无，平台返回仅可选择有，则以平台配置为准，资料中发票配置有；</div>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="tm" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
                    <div class="btns">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="500px">
            <el-form :model="editForm" label-width="120px">
                <el-form-item label="发票:">
                    <el-radio-group v-model="editForm.has_invoice">
                        <el-radio :label="1">有</el-radio>
                        <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="保修:">
                    <el-radio-group v-model="editForm.has_warranty">
                        <el-radio :label="1">有</el-radio>editDialogVisible
                        <el-radio :label="0">无</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="退换货服务:">
                    <el-radio-group v-model="editForm.sell_promise">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="拍下减库存:">
                    <el-radio-group v-model="editForm.sub_stock">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否支持会员折扣:">
                    <el-radio-group v-model="editForm.has_discount">
                        <el-radio :label="1">支持会员打折</el-radio>
                        <el-radio :label="0">不支持会员打折</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="返点比例:">
                <el-input v-model="editForm.auction_point" style="width: 60px"
                @input="editForm.auction_point = editForm.auction_point.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')">
                </el-input>
                <span class="unit"> %</span>
                </el-form-item>
                <el-form-item label="商品状态:">
                    <el-radio-group v-model="editForm.item_status">
                        <el-radio :label="0" value='0'>立即上架</el-radio>
                        <el-radio :label="2" value="2">放入仓库</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="发布类型">
                    <el-select v-model="editForm.item_type" placeholder="请选择发布类型">
                    <el-option label="一口价" value="b"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitEdit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog-select-shop
            :selected="shopIds"
            placeholder="选择店铺"
            :shopData="shopListAll"
            :visible.sync="visible"
            @confirm="confirmSelectShop"
        />
        <el-dialog
            title="解除关联并绑定配置"
            :visible.sync="unbindDialogVisible"
            width="30%"
        >
            <div>以下店铺已关联售后配置，是否解除关联后绑定该配置？</div>
            <span v-for="(shop, index) in selectedShops" :key="index" style="font-size:12px">
                <el-image :src="shop.icon" style="width: 12px;" />
                {{ shop.title }}
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="unbindDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="unbindAndBindConfig">确 定</el-button>
            </span>
        </el-dialog>
        <ProductParamImageDialog
            :visible.sync="productParamDialogVisible"
            @success="handleProductParamImageSuccess"
        />
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getTMTemplateList} from '@servers/prod/conf/index.js';
import {getShopList} from '@servers/base/shop/index.js';
import PriceConf from './components/PriceConf.vue';
import ImageMappingConfig from './components/ProductParamImageConfig/ImageMappingConfig.vue';
import ProductParamImageDialog from './components/ProductParamImageConfig/ProductParamImageDialog.vue';
import ImgUpload from '@/components/Uploads/ImgUpload.vue';
import { queryCategoryImageConfig } from '@/api/prod/conf/index.js';
import { mapGetters } from 'vuex';

const PLATFORMID = 'tm';

export default {
    props: {
        back: Function
    },
    components: {
        PriceConf,
        ImageMappingConfig,
        ProductParamImageDialog,
        ImgUpload,
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]*$/;
            if (value === '') {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须是数字, 且为整数'))
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'))
            } else {
                callback();
            }
        }
        return {
            checkInstock: false,
            shopList: [],
            value: {
                titleSet: true,
                isAutoFillOuterId: 0,
                instock: null,
                shelfType: 2,
                autoCropImageConfigList:[],
                verticalImageConfigVO: {
                    defaultMapping: 'longImage',
                    useTmall: 0,
                    tmIndex: 1,
                    tmImageType: 'tmallItemImage',
                },
                transparentImageConfigVO: {
                    defaultMapping: 'whiteBgImage',
                    useTmall: 0,
                    tmIndex: 1,
                    tmImageType: 'tmallItemImage',
                },
                productParamImageConfigVO: {
                    useCommonConfig: false,
                    useCategoryConfig: false,
                    commonImageUrl: '',
                    commonImageId: '',
                },
            },
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: ''},
                ]
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表
            },
            isEdit: false, // 用于区分是编辑还是新增
            dialogTitle: '新增售后配置', // 弹框标题
            tableData:[], // 售后配置列表
            editDialogVisible: false, // 售后配置弹框
            editForm: { // 新增时的默认值
                has_invoice: 1,
                has_warranty: 0,
                sell_promise: 0,
                sub_stock: 0,
                has_discount: 0,
                item_status: 2,
                item_type: 'b',
                auction_point: '0.50'
            },
            multipleSelection: [], // 用于存储多选的行
            visible: false, // 店铺弹框
            shopListAll: [],
            shopIds:'',
            unbindDialogVisible:false,
            selectedShops:[],
            productParamDialogVisible: false, // 产品参数图片类目配置弹窗
            categoryConfigCount: 0, // 类目配置数量
        }
    },
    computed: {
      ...mapGetters(['get_AllShops_BySource']),
      imageMappingTableData() {
        return [
          { type: 'vertical', name: '商品竖图' },
          { type: 'transparent', name: '透明素材图' },
          { type: 'param', name: '产品参数图片' },
        ];
      },
  },
    mounted() {
        this.getConf();
    },
    methods: {
        // 打开店铺弹窗
        async showShopSelect(index, row) { 
            this.shopIds = row.shops && row.shops.map(shop => shop.userId).join(',');
            this.currentEditIndex = index;
            this.visible = true;
        },
        // 店铺选择
        confirmSelectShop(shops) {
            // 从选择的店铺中找到是否已经有对应的适配店铺，selectedShops则是适配店铺
            let shopsSx = shops.filter(shop => !this.shopIds.includes(shop.userId)).map(shop=>shop.userId);
            
            let selectedShops = [], selectedUserIds=[];
            this.tableData.forEach(item => {
                item.shops && item.shops.forEach(shop => {
                    if (shopsSx.includes(shop.userId)) {
                        selectedShops.push(shop);
                        selectedUserIds.push(shop.userId)
                    }
                });
            });
            if(selectedShops.length){
                this.unbindDialogVisible = true;
                this.selectedShops = selectedShops;
                this.shopIds = this.shopIds ? this.shopIds.split(',').concat(selectedUserIds) : selectedUserIds;
            }else{
                this.shopIds = shops.map(shop => shop.userId);
                this.relevanceShops();
            }
        },
        // 将关联店铺更新到列表中
        relevanceShops(){
            this.tableData[this.currentEditIndex].afterShopIds = this.shopIds.join(',');

            let shopNames = this.shopIds.map(id => {
                let shop = this.shopListAll.find(s => s.userId == id);
                if(shop){
                    return {
                        title: shop.shortTitle || shop.title,
                        icon: shop.icon,
                        userId: shop.userId
                    }
                }
            }).filter(Boolean);
            this.tableData[this.currentEditIndex].shops = shopNames;
        },
        // 确定解除对应店铺
        unbindAndBindConfig(){
            this.tableData.forEach(item => {
                let userIdsSelect = this.selectedShops.map(shop=>shop.userId).join(',')
                item.shops = item.shops && item.shops.filter(shop => !userIdsSelect.includes(shop.userId));
                item.afterShopIds = item.shops && item.shops.map(shop => shop.userId).join(',');
            });

            this.relevanceShops();
            this.unbindDialogVisible=false;
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        // 新增配置按钮点击事件
        handleAdd() {
            this.isEdit = false;
            this.dialogTitle = '新增售后配置';
            this.editForm = {has_invoice: 0,has_warranty: 0,sell_promise: 0,sub_stock: 0,has_discount: 0,item_status:2,item_type:'b',auction_point: ''};
            this.editDialogVisible = true;
        },
        // 修改编辑方法
        handleEdit(index, row) {
            this.isEdit = true;
            this.dialogTitle = '编辑售后配置';
            this.currentEditIndex = index;
            this.editForm = {
                has_invoice: row.afterOther.has_invoice,  // 根据实际数据设置
                has_warranty: row.afterOther.has_warranty,
                sell_promise: row.afterOther.sell_promise,
                sub_stock: row.afterOther.sub_stock,
                has_discount: row.afterOther.has_discount,
                item_status: row.afterOther.item_status,
                item_type: row.afterOther.item_type,
                auction_point: row.afterOther.auction_point
            };
            this.editDialogVisible = true;
        },
        // 修改提交方法
        submitEdit() {
            const configDetail = `发票：${this.editForm.has_invoice ? '有' : '无'}，
                保修：${this.editForm.has_warranty ? '有' : '无'}，
                退换货服务：${this.editForm.sell_promise ? '有' : '无'}，
                拍下减库存：${this.editForm.sub_stock ? '有' : '无'}，
                是否支持会员折扣：${this.editForm.has_discount ? '支持会员打折' : '不支持会员打折'}，
                返点比例：${this.editForm.auction_point},
                商品状态: ${this.editForm.item_status ? '放入仓库' : '立即上架'}，
                发布类型: ${this.editForm.item_type ? '一口价' : ''}，
                `;


            const configDetailJson = {
                has_invoice: this.editForm.has_invoice,
                has_warranty: this.editForm.has_warranty,
                sell_promise: this.editForm.sell_promise,
                sub_stock: this.editForm.sub_stock,
                has_discount: this.editForm.has_discount,
                item_status: this.editForm.item_status,
                item_type: this.editForm.item_type,
                auction_point: this.editForm.auction_point
            }
            
            if (this.isEdit) {
                // 编辑模式
                this.tableData[this.currentEditIndex].configDetail = configDetail;
                this.tableData[this.currentEditIndex].afterOther = configDetailJson;
            } else {
                // 新增模式
                this.tableData.push({
                    configDetail,
                    afterOther: configDetailJson,
                    afterShopIds:'',
                    shops: '', // 新增时店铺为空
                    options: ''
                });
            }
            
            this.editDialogVisible = false;
            this.$message.success(this.isEdit ? '修改成功' : '新增成功');
        },
        handleLinkShop(index, row) {
            // 处理关联店铺逻辑
        },
        handleDelete(index, row) {
            this.$confirm('确认要删除选中的售后配置吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.tableData.splice(index, 1);
            }).catch(() => {});
        },
        // 批量删除方法
        handleBatchDelete() {
            if (this.multipleSelection.length === 0) {
                this.$message.warning('请选择要删除的配置');
                return;
            }
            
            this.$confirm(`确认要删除选中的售后配置吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const selectedIds = this.multipleSelection.map(item => this.tableData.indexOf(item));
                // 从后往前删除，避免索引变化
                selectedIds.sort((a, b) => b - a).forEach(index => {
                    this.tableData.splice(index, 1);
                });
            }).catch(() => {});
        },

        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID});
            // 获取天猫模板
            const shopList = this.$store.getters.get_AllShops_BySource('tm');
            this.shopList = shopList;

            if (res) {
                this.checkInstock = res.isCommodityStock === 1;
                this.value.titleSet = res.isCommodityTitle === 1;
                this.value.isAutoFillOuterId = res.isAutoFillOuterId || 0;
                this.value.instock = res.stockNumber;
                this.value.shelfType = res.shelfState || this.value.shelfType;
                this.value.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
                this.value.price = res.price ? JSON.parse(res.price) : [];
                this.value.shopPriceConf = res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
                this.value.address = res.address && [res.address.prov, res.address.city, -1, -1];
                // 图片映射配置
                this.value.verticalImageConfigVO = res.verticalImageConfigVO ? {
                    defaultMapping: res.verticalImageConfigVO.defaultMapping,
                    useTmall: res.verticalImageConfigVO.useTmall,
                    tmIndex: res.verticalImageConfigVO.tmIndex,
                    tmImageType: res.verticalImageConfigVO.tmImageType,
                    optionalRules: res.verticalImageConfigVO.optionalRules,
                } : {
                    defaultMapping: 'longImage',
                };
                this.value.transparentImageConfigVO = res.transparentImageConfigVO ? {
                    defaultMapping: res.transparentImageConfigVO.defaultMapping,
                    useTmall: res.transparentImageConfigVO.useTmall,
                    tmIndex: res.transparentImageConfigVO.tmIndex,
                    tmImageType: res.transparentImageConfigVO.tmImageType,
                    optionalRules: res.transparentImageConfigVO.optionalRules,
                } : {
                    defaultMapping: 'whiteBgImage',
                };
                if (res.productParamImageConfigVO) {
                    // 字段映射：后端返回 useGeneralConfig/generalImageUrl，前端使用 useCommonConfig/commonImageUrl
                    this.$set(this.value.productParamImageConfigVO, 'useCommonConfig', !!res.productParamImageConfigVO.useGeneralConfig);
                    this.$set(this.value.productParamImageConfigVO, 'commonImageUrl', res.productParamImageConfigVO.generalImageUrl || '');
                    this.$set(this.value.productParamImageConfigVO, 'useCategoryConfig', !!res.productParamImageConfigVO.useCategoryConfig);
                }
            }

            this.initTemplate(shopList, res && res.templateList);
            //售后显示转化
            this.getAfterSaleTempList(res);

            // 通过新接口获取类目配置数量
            this.fetchCategoryConfigCount();
        },

        //售后显示转化
        async getAfterSaleTempList(res){
            // 获取所有tm店铺信息
            const shopRes = await getShopList({
                source: 'tm',
                pageNo: 1,
                pageSize: 500
            });
            this.shopListAll = shopRes.list || [];

            let afterSaleOtherList = res.afterSaleOtherList || [];

            this.tableData = afterSaleOtherList?.map(item => {
                let afterOther = item.afterOther;
                let shopStr= item.afterShopIds && item.afterShopIds.split(',');

                let shopNames = shopStr && shopStr.map(id => {
                    let shop = this.shopListAll.find(s => s.userId == id);
                    if(shop){
                        return {
                            title: shop.shortTitle || shop.title,
                            icon: shop.icon,
                            userId: shop.userId
                        }
                    }
                }).filter(Boolean);

                return {
                    shops:shopNames,
                    afterOther:afterOther,
                    afterShopIds: item.afterShopIds,
                    configDetail: `发票：${afterOther.has_invoice ? '有' : '无'}，保修：${afterOther.has_warranty ? '有' : '无'}，退换货服务：${afterOther.sell_promise ? '有' : '无'}，拍下减库存：${afterOther.sub_stock ? '有' : '无'}，是否支持会员折扣：${afterOther.has_discount ? '支持会员打折' : '不支持会员打折'}，返点比例：${afterOther.auction_point},商品状态：${afterOther.item_status?'放入仓库':'立即上架'},发布类型：${afterOther.item_type ?'一口价':''}`
                };
            });
        },
        async getTemplateList(userId) {
            const list = await getTMTemplateList({userId: userId});
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.name,
                        id: ship.templateId
                    }
                });
            }
            return [];
        },
        async refreshTemplate(shopId, userId) {
            this.selectLoading = true;
            const list = await this.getTemplateList(userId);
            this.shipsTemplate[shopId] = list;
            const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            if (idx === -1) {
                this.shipsValue[shopId] = '';
            }
            this.selectLoading = false;
            this.$message.success('刷新模板成功');
        },
        initTemplate(shopList, templateList=[]) {
            const ships = {};
            const shopUserIdMap = {};
            for(let shop of shopList) {
                ships[shop.id] = '';
                shopUserIdMap[shop.userId] = shop.id;
                this.shipsTemplate[shop.id] = [];
            }
            const shipsTemp = {};
            if (shopList.length && templateList) {
                    templateList.forEach(item => {
                        item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                        ships[item.shopId] = item.templateId;
                        if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
                            shipsTemp[item.shopId] = [{name: item.templateName, id: item.templateId}]
                        }
                    })
            }
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        async changeSelect(shopId, userId) {
            if (!this.shipsTemplate[shopId] || !this.shipsTemplate[shopId].length ||
                (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])) {
                this.selectLoading = true;
                const list = await this.getTemplateList(userId)
                const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
                if (idx === -1) {
                    this.shipsValue[shopId] = '';
                }
                this.shipsTemplate[shopId] = list;
                this.selectLoading = false;
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id === tempId) {
                    return item.name;
                }
            }
        },
        // ==================== 图片映射配置相关方法 ====================
        handleProductParamImageChange() {
            // 产品参数图片配置变化处理
        },
        openCategoryConfigDialog() {
            this.productParamDialogVisible = true;
        },
        handleProductParamImageSuccess() {
            // 保存成功后重新获取已配置数量
            this.fetchCategoryConfigCount();
        },
        async fetchCategoryConfigCount() {
            try {
                const res = await queryCategoryImageConfig({ shopType: 'tm' });
                if (res.result === 1 && res.data) {
                    const total = res.data.total || res.data.count || 0;
                    this.categoryConfigCount = total;
                    this.$set(this.value.productParamImageConfigVO, 'categoryConfigCount', total);
                }
            } catch (e) {
                console.error('fetchCategoryConfigCount error', e);
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        titleSet,
                        isAutoFillOuterId,
                        imgNumSet,
                        instock,
                        shelfType,
                        autoCropImageConfigList,
                        address
                    } = this.value;
                    const templateList = []
                    Object.keys(this.shipsValue).forEach(id => {
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        if (name) {
                            const channel = this.shopList.find(shop => shop.id == id)?.channel
                            templateList.push({
                                shopId: id,
                                templateId: this.shipsValue[id] || null,
                                templateName: name || null,
                                channel
                            });
                        }
                    });
                    
                    const afterSaleDetails = this.tableData.map(item => ({
                        afterOther: item.afterOther,
                        afterShopIds: item.afterShopIds
                    }));
                    let [commConf,shopConf] = this.$refs.PriceConfRef.getData();

                    // 构建 verticalImageConfigVO
                    const verticalVO = {
                        defaultMapping: this.value.verticalImageConfigVO.defaultMapping,
                    };
                    if (this.value.verticalImageConfigVO.optionalRules) {
                        verticalVO.optionalRules = {
                            index: this.value.verticalImageConfigVO.optionalRules.index,
                            sourceType: this.value.verticalImageConfigVO.optionalRules.sourceType,
                        };
                    }

                    // 构建 transparentImageConfigVO
                    const transparentVO = {
                        defaultMapping: this.value.transparentImageConfigVO.defaultMapping,
                    };
                    if (this.value.transparentImageConfigVO.optionalRules) {
                        transparentVO.optionalRules = {
                            index: this.value.transparentImageConfigVO.optionalRules.index,
                            sourceType: this.value.transparentImageConfigVO.optionalRules.sourceType,
                        };
                    }

                    const res = await updateDistributionConfig({
                        shopType: PLATFORMID,
                        isCommodityTitle: titleSet ? 1 : 0,
                        isCommodityImage: imgNumSet ? 1 : 0,
                        isAutoFillOuterId: isAutoFillOuterId || 0,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        shelfState: shelfType,
                        autoCropImageConfigList,
                        templateList: templateList,
                        price: JSON.stringify(commConf),
                        shopPriceConf:JSON.stringify(shopConf),
                        address:{
                            prov: address && address[0],
                            city: address && address[1]
                        },
                        afterSaleOtherList:afterSaleDetails,
                        verticalImageConfigVO: verticalVO,
                        transparentImageConfigVO: transparentVO,
                        productParamImageConfigVO: {
                            useGeneralConfig: this.value.productParamImageConfigVO.useCommonConfig,
                            useCategoryConfig: this.value.productParamImageConfigVO.useCategoryConfig,
                            generalImageUrl: this.value.productParamImageConfigVO.commonImageUrl,
                        },
                    });
                    if (res) {
                        this.$message.success('保存成功');
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-image__inner{
    vertical-align: bottom !important;
}

.mapping-rule {
    width: 100%;
    padding: 20px;
}

.rule-line {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.divider {
    color: #dcdfe6;
    margin: 0 4px;
}

.rule-label {
    font-size: 12px;
    color: #606266;
}

.rule-tip {
    font-size: 12px;
    color: red;
    line-height: 1.5;
    margin-top: 8px;
}

.common-config-upload {
    margin-top: 15px;
}
</style>